<template>
  <VCard class="elevation-12">
    <VCardTitle :class="[color, 'white--text']">
      <VLayout row wrap justify-center>
        <VFlex xs12 text-xs-center>
          <h2>No Shift</h2>
        </VFlex>
      </VLayout>
    </VCardTitle>

    <VCardText class="pa-4 text-xs-center">
      <!-- Icon -->
      <VIcon size="80" color="grey lighten-1" class="my-4">
        event_busy
      </VIcon>

      <!-- No shifts message -->
      <h3 class="mb-4">No Shift Found</h3>

      <p class="body-1 grey--text text--darken-1 mb-4">
        You don't have a shift scheduled for this day.
      </p>

      <!-- Contact info -->
      <VAlert :value="true" type="info" outline class="text-xs-left">
        If you believe this is an error, please contact the WCI Dispatcher.
      </VAlert>
    </VCardText>
  </VCard>
</template>

<script>
import { VLayout, VFlex } from 'vuetify/lib'
import { VCard, VCardTitle, VCardText } from '@vuetify/VCard'
import VIcon from '@vuetify/VIcon'
import VAlert from '@vuetify/VAlert'

export default {
  name: 'NoShiftMessage',
  components: {
    VLayout,
    VFlex,
    VCard,
    VCardTitle,
    VCardText,
    VIcon,
    VAlert,
  },
  props: {
    color: {
      type: String,
      default: 'grey darken-1',
    },
  },
}
</script>

<style scoped>
.v-card__title h2 {
  font-weight: 500;
}
</style>
